// test748
(748 && 0);
